<template>
  <div>
    <div
      v-if="showViewModal"
      class="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
    >
      <div class="relative w-full h-full p-4">
        <div class="relative w-full h-full bg-white rounded">
          <div class="flex items-center justify-between px-2 py-4">
            <p class="pl-2 font-medium text-black">Property View on Map</p>
            <button
              type="button"
              class="absolute right-0 flex items-center justify-center p-1 ml-auto text-sm font-thin text-black bg-transparent bg-gray-200 rounded-full w-14 hover:text-gray-900"
              @click="closeViewModal()"
              data-modal-toggle="show-login-modal"
            >
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
          </div>
          <hr />
          <div class="flex flex-col h-full">
            <div id="map" class="w-full h-full"></div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showViewModal"
      class="fixed inset-0 z-40 bg-black opacity-25"
    ></div>
  </div>
</template>

<script setup>
import { defineProps, getCurrentInstance, watch } from "vue";
import { useStore } from "vuex";
const props = defineProps({
  showViewModal: Boolean,
  address: String,
});
const store = useStore();
const google_map_api_key = store.state.google_map_api_key;
const { emit } = getCurrentInstance();

const closeViewModal = () => {
  emit("closeViewModal");
};

const loadGoogleMapsScript = () => {
  return new Promise((resolve, reject) => {
    if (window.google) {
      resolve(window.google);
      return;
    }
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${google_map_api_key}&callback=initGoogleMaps`;
    script.async = true;
    script.defer = true;
    window.initGoogleMaps = () => resolve(window.google);
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

const initMap = (google) => {
  const mapOptions = {
    center: { lat: 0, lng: 0 },
    zoom: 20,
  };
  const map = new google.maps.Map(document.getElementById("map"), mapOptions);

  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ address: props.address }, (results, status) => {
    if (status === "OK") {
      map.setCenter(results[0].geometry.location);
      map.setZoom(18);

      new google.maps.Marker({
        map,
        position: results[0].geometry.location,
      });
    } else {
      console.error(
        "Geocode was not successful for the following reason:",
        status
      );
    }
  });
};

watch(
  () => props.showViewModal,
  (newVal) => {
    if (newVal) {
      loadGoogleMapsScript()
        .then((google) => {
          initMap(google);
        })
        .catch((error) => {
          console.error("Error loading Google Maps:", error);
        });
    }
  }
);
</script>
<style scoped>
#map {
  height: 100%;
  width: 100%;
}
</style>
